<main>
  <section class="__main-section">
    <!-- Header -->
    <header class="__header">
      <div class="__header-wrapper">
        <h1 class="__header-name">{{(selectedOrganization$ | async)?.name}}</h1>
        <ng-container
          *ngIf="(selfOrganizationUser$ | async) && ((selfOrganizationUser$ | async)?.role) !== OrganizationUserRole.Member">
          <!-- Grid, Floor Toggle -->
          <awair-grid-floor-toggle class="__header-right"
                                   [selectedListPane]="(selectedListPane$ | async)"
                                   (selectedItem)="switchListPane($event)">
          </awair-grid-floor-toggle>
          <!-- /.Grid, Floor Toggle -->
        </ng-container>
      </div>
    </header>
    <!-- /.Header -->
    <!-- Device Grid -->
    <div class="device-grid-container">
      <ng-container *ngIf="((selfOrganizationUser$ | async)?.role) !== OrganizationUserRole.Member; else member">
        <ng-container [ngSwitch]="(selectedListPane$ | async)">
          <awair-floor-plan *ngSwitchCase="ListPaneType.Floor">
          </awair-floor-plan>
          <awair-device-grid *ngSwitchDefault>
          </awair-device-grid>
        </ng-container>
      </ng-container>
      <ng-template #member>
        <awair-device-grid></awair-device-grid>
      </ng-template>
      <awair-backdrop *ngIf="isDeviceGridBackdrop"
                      [zIndex]="backdropZIndex"
                      [height]="'100%'"
                      [backgroundColor]="backdropColor"
                      [opacity]="backdropOpacity">
      </awair-backdrop>
      <awair-backdrop *ngIf="isDeviceGridTransparentBackdrop"
                      [zIndex]="transparentBackdropZIndex"
                      [height]="'100%'"
                      [backgroundColor]="'#FFFFFF'"
                      [opacity]="0">
      </awair-backdrop>
    </div>
    <!-- /.Device Grid -->

    <!-- Timeline -->
    <div class="timeline-container">
      <awair-timeline class="__timeline"
                      (pinnedNoti)="pinnedNoti($event)"
                      (removedNoti)="removedNoti()">
      </awair-timeline>
      <awair-backdrop *ngIf="isTimelineBackdrop"
                      [zIndex]="backdropZIndex"
                      [backgroundColor]="backdropColor"
                      [opacity]="backdropOpacity">
      </awair-backdrop>
    </div>
    <!-- /.Timeline -->
  </section>

  <!-- Feed Pane -->
  <section class="__feed-section" awairScrollPrevent>
    <router-outlet></router-outlet>
    <awair-backdrop *ngIf="isFeedBackdrop"
                    [zIndex]="backdropZIndex"
                    [backgroundColor]="backdropColor"
                    [opacity]="backdropOpacity">
    </awair-backdrop>
  </section>
  <!-- /.Feed Pane -->
</main>
